const AppPermissions = {
  // Indexes permission menu
  IndexesRead: 'IndexesRead',
  IndexesWrite: 'IndexesWrite',
  IndexesDelete: 'IndexesDelete',
  IndexesSave: 'IndexesSave',

  // Notifications permission menu
  NotificationsRead: 'NotificationsRead',
  NotificationsWrite: 'NotificationsWrite',
  NotificationsDelete: 'NotificationsDelete',

  // Notifications permission menu
  KIEngineRead: 'KIEngineRead',
  KIEngineWrite: 'KIEngineWrite',
  KIEngineDelete: 'KIEngineDelete',

  // Chat permission menu
  ChatRead: 'ChatRead',
  ChatWrite: 'ChatWrite',
  ChatDelete: 'ChatDelete',
  ChatbotRead:"ChatbotRead",
  ChatbotSave: 'ChatbotSave',
  ChatbotWrite: 'ChatbotWrite',
  ChatbotDelete: 'ChatbotDelete',

  // Users permission menu
  UsersRead: 'UsersRead',
  UsersWrite: 'UsersWrite',
  UsersDelete: 'UsersDelete',
  UsersAvatarRead: 'UsersAvatarRead',
  UserAvatarRead: 'UserAvatarRead',
  UserAvatarWrite: 'UserAvatarWrite',

  // User feelings permission menu
  UserFeelingsWrite: 'UserFeelingsWrite',

  ProfilesRead: 'ProfilesRead',
  ProfilesWrite: 'ProfilesWrite',
  ProfilesDelete: 'ProfilesDelete',
  ProfilePermissionsRead: 'ProfilePermissionsRead',
  ProfilePermissionsWrite: 'ProfilePermissionsWrite',
  ProfilePermissionsDelete: 'ProfilePermissionsDelete',
  ProfilePermissionsAssign: 'ProfilePermissionsAssign',
  ProfilePermissionsUnassign: 'ProfilePermissionsUnassign',

  // Support permission menu
  SupportWrite: 'SupportWrite',

  // For Admin
  AccessAll: 'AccessAll',
};

export { AppPermissions };
